<script setup lang="ts">
import ImageThumbnail from 'Common/components/elements/images/ImageThumbnail.vue'
import type { ImageDetailType } from 'Modules/types/generic/image/imageDetailType'
import { useRoute, useRouter } from 'vue-router'
import { JeteyeRoutes } from 'Modules/RouterSetup'

const emit = defineEmits(['onClick', 'onImagesLoaded'])

interface PropTypes {
  workcardImagesDetailList: Array<ImageDetailType>
  imageLoading?: 'lazy' | 'eager'
  inspectionInstance: string
}
const props = defineProps<PropTypes>()
const route = useRoute()
const router = useRouter()

const getReviewUrl = (imageUuid: string) => {
  const baseUrl = window.location.origin
  return `${baseUrl}/review?inspectionInstance=${props.inspectionInstance}&inspectionImage=${imageUuid}`
}

const handleClick = (uuid: string): void => {
  if (uuid && route.query.inspectionInstance) {
    const query: Record<string, any> = {
      inspectionInstance: route.query.inspectionInstance,
      inspectionImage: [uuid],
    }

    if (route.query.workcardDefinition) {
      query.workcardDefinition = route.query.workcardDefinition
    }

    router.push({
      name: JeteyeRoutes.ImageReview,
      query: query,
    })
  } else {
    console.error("Image and Inspection Instance UUID's are not defined and are required to build review page url.")
  }
}

let imagesLoaded = 0
const handleLoaded = () => {
  if (props.workcardImagesDetailList.length === 0) {
    // if we have no images to load lets push loaded event as its compelte
    emit('onImagesLoaded', true)
    return
  }
  imagesLoaded++
  if (imagesLoaded >= props.workcardImagesDetailList.length) {
    emit('onImagesLoaded', true)
  }
}
</script>

<template>
  <div class="mx-auto px-2 py-4 w-full">
    <div class="flex flex-wrap gap-2 items-center justify-start">
      <template v-for="(item, i) in props.workcardImagesDetailList" :key="`${item.imageName}-${i}`">
        <div class="w-48">
          <ImageThumbnail
            :uuid="item.imageUuid"
            :review-url="getReviewUrl(item.imageUuid)"
            :image-description="item.imageName"
            :image-url="item.thumbnailImageUrl"
            :viewed="item.reviewState !== 'Not Started'"
            :approved="item.reviewState === 'Complete'"
            border-color="sky-600"
            :image-loading="props.imageLoading"
            @on-click="handleClick"
            @on-loaded="handleLoaded"
          />
        </div>
      </template>
    </div>
  </div>
</template>
